import { render, staticRenderFns } from "./EventField.vue?vue&type=template&id=4b6310b9&"
import script from "./EventField.vue?vue&type=script&lang=js&"
export * from "./EventField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports